import * as React from 'react';

import { emoji } from '@gitbook/doc-core';
import { createPickEmojiPalette } from '@gitbook/react-uikit';
import type { TextRange } from '@gitbook/slate';
import type { MarkProps } from '@gitbook/slate-react';

import { SelectionPalettePicker } from '../common';

/**
 * Component being rendered around the temporary mark created when typing ":".
 */
export function EmojiPickerMark(props: MarkProps): React.ReactElement {
    const { editor } = props;

    const getPalette = React.useCallback(
        (_markData: { value: string }, getCurrentRange: () => TextRange) => {
            const replaceWithEmoji = (code: string) => {
                editor.change((change) => {
                    change.insertInlineAtRange(getCurrentRange(), emoji.createEmoji(code)).focus();
                });
            };

            return createPickEmojiPalette(replaceWithEmoji, {
                withSearch: false,
            });
        },
        [editor]
    );

    return <SelectionPalettePicker {...props} getPalette={getPalette} />;
}
